import React, { useEffect, useState } from 'react';
import { Color } from '../../../const/Const';
import { Persona, PersonaSize } from '@fluentui/react';
import { API } from '../../../API/API';
import { Pivot, PivotItem } from '@fluentui/react';
import { useParams, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { LoadScreen } from '../../../components/LoadScreen/LoadScreen';
import EmpEmplHist from '../EmpEmplHist/EmpEmplHist';
import EmpExtraBusiness from '../EmpExtraBusiness/EmpExtraBusiness';
import User from '../User/User';
import BasicInformation from '../BasicInformation/BasicInformation';

const Employee = (props) => {

    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    const [dUser, setDUser] = useState({});
    const [loading, setLoading] = useState(false);

    const getData = async () => {
        let tUser = location?.state ? location?.state : {};
        if (params?.empid > 0) {
            try {
                setLoading(true);
                await API.get('/api/humanresource/employee/get?EmployeeID=' + params?.empid).then(response => {
                    if (response.status === 200 && response.data.rettype === 0) {
                        if (response.data?.retdata?.length > 0 && response.data?.retdata[0]) {
                            tUser = response.data?.retdata[0];
                        } else {
                            navigate('/notfound');
                        }
                    }
                });
            } finally {
                setLoading(false);
            }
        } else if (params?.empid != -1) {
            navigate('/notfound');
        }
        setDUser(tUser);
    }

    useEffect(() => {
        getData();
    }, [params?.empid]);

    const onLinkClick = (pTab) => {
        if (params?.empid > 0) {
            navigate('/hrsuite/employee/' + params?.empid + "?tab=" + pTab?.props?.itemKey);
        }
    }

    if (loading) {
        return (
            <LoadScreen />
        );
    }

    return (
        <div>
            <div style={{ height: 56, display: 'flex', alignItems: 'center', marginTop: 16, marginBottom: 16, marginLeft: 16, marginRight: 16, justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', }}>
                    <div>
                        {dUser.picturedata ? (
                            <div style={{ borderRadius: 28, overflow: 'hidden', border: 0 }}>
                                <img height={56} src={"data:image/png;base64, " + dUser.picturedata} />
                            </div>
                        ) : (
                            <Persona hidePersonaDetails text={dUser.firstname} size={PersonaSize.size56} />
                        )}
                    </div>
                    <div style={{ marginLeft: 16 }}>
                        <div style={{ fontSize: 20 }}>
                            <span style={{ textTransform: 'capitalize' }}>{dUser?.lastname ? (dUser?.lastname?.substr(0, 1) + ". ") : ""}{dUser?.firstname}</span>
                        </div>
                        <div style={{ fontSize: 14, color: Color.grayText }}>
                            {dUser.depname} {dUser.posname ? ", " + dUser.posname : "--"}
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginRight: 8 }}>
                    <div>
                        <div style={{ fontWeight: 600, fontSize: 16, color: Color.blue }}>
                            Төлөв
                        </div>
                        <div style={{ color: Color.graySecond }}>
                            {dUser.statusname ? dUser.statusname : '--'}{dUser.emptype == "C" ? ", " + "Давхар ажил эрхлэлт" : ""}
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <Pivot
                    selectedKey={searchParams.get("tab") ? searchParams.get("tab") : "0"}
                    styles={{
                        linkIsSelected: {
                            '&::before': {
                                backgroundColor: Color.primary
                            }
                        },
                        root: {
                            paddingLeft: 7,
                            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.15), inset 0px -1px 0px rgba(217, 217, 217, 0.25)'
                        }
                    }}
                    onLinkClick={onLinkClick}
                >
                    <PivotItem headerText='Ажил эрхлэлт' itemKey='empemplhist'>
                        <EmpEmplHist />
                    </PivotItem>
                    <PivotItem headerText='Үндсэн мэдээлэл' itemKey='basic'>
                        <BasicInformation />
                    </PivotItem>
                    <PivotItem headerText='Нэмэгдэл' itemKey='benefitbusiness'>
                        <EmpExtraBusiness />
                    </PivotItem>
                    <PivotItem headerText='Хэрэглэгч' itemKey='user'>
                        <User />
                    </PivotItem>
                </Pivot>
            </div>
        </div>
    );
}

export default Employee;